module.exports = __webpack_public_path__ + "static/WP-3x-4b32f5134892f2cfad77c52c5798d85b.pdf";